import Loadable from 'app/components/Loadable/Loadable'
import { lazy } from 'react'
import { authRoles } from '../../auth/authRoles'

const Analytics = Loadable(lazy(() => import('./Analytics')))
const EditProduct = Loadable(lazy(() => import('./EditProduct')))

//Posts
// const AddInterest = Loadable(
//     lazy(() => import('../eld/interests/AddInterest/AddInterest'))
// )
// const EditInterest = Loadable(
//     lazy(() => import('../eld/interests/EditInterest/EditInterest'))
// )
const Emails = Loadable(lazy(() => import('../viral/emailList/EmailList')))
const ChatbotData = Loadable(lazy(() => import('../viral/chatbotData/chatbotData')))
const ModelInput = Loadable(lazy(() => import('../viral/modelInput/modelInput')))
const Orders = Loadable(lazy(() => import('../viral/help/Help')))
const Towns = Loadable(lazy(() => import('../viral/towns/Towns')))
const Stadiums = Loadable(lazy(() => import('../viral/stadiums/Stadiums')))
const Pages = Loadable(lazy(() => import('../viral/pages/Pages')))
const Photos = Loadable(lazy(() => import('../viral/photos/Photos')))
const Colors = Loadable(lazy(() => import('../viral/characters/colors')))
const ProductTypes = Loadable(
    lazy(() => import('../viral/currencies/Currencies'))
)
const Overrides = Loadable(lazy(() => import('../viral/overrides/overrides')))
const Categories = Loadable(
    lazy(() => import('../viral/categories/categories'))
)
const Characters = Loadable(
    lazy(() => import('../viral/characters/Characters'))
)
const EditCharacter = Loadable(
    lazy(() => import('../viral/characters/editCharacter'))
)
const Parts = Loadable(lazy(() => import('../viral/characters/parts')))
const EditPart = Loadable(lazy(() => import('../viral/characters/editPart')))
const Vendors = Loadable(lazy(() => import('../viral/vendors/vendors')))
const Customers = Loadable(lazy(() => import('../viral/customers/customers')))
const References = Loadable(
    lazy(() => import('../viral/references/References'))
)

const Suppliers = Loadable(lazy(() => import('../viral/vendors/suppliers')))
const Managers = Loadable(lazy(() => import('../viral/vendors/managers')))
const ViewOrder = Loadable(lazy(() => import('../viral/layouts/Layouts')))
const Revisions = Loadable(lazy(() => import('../viral/revisions/Revisions')))
const Employees = Loadable(lazy(() => import('../viral/vendors/employees')))
const Accountability = Loadable(
    lazy(() => import('../viral/accountability/Accountability'))
)
const Blogs = Loadable(lazy(() => import('../viral/blogs/Blogs')))
const Chat = Loadable(lazy(() => import('../viral/chat')))
const Reports = Loadable(lazy(() => import('../viral/reports/Reports.jsx')))

const dashboardRoutes = [
    {
        path: '/dashboard/default',
        element: <Analytics />,
        auth: authRoles.admin,
    },
    {
        path: '/references',
        element: <References />,
        auth: authRoles.admin,
    },
    {
        path: '/overrides',
        element: <Overrides />,
        auth: authRoles.admin,
    },
    {
        path: '/categories',
        element: <Categories />,
        auth: authRoles.admin,
    },
    {
        path: '/colors',
        element: <Colors />,
        auth: authRoles.admin,
    },
    {
        path: '/characters',
        element: <Characters />,
        auth: authRoles.admin,
    },
    {
        path: '/modelInput',
        element: <ModelInput />,
        auth: authRoles.admin,
    },
    {
        path: '/editCharacter',
        element: <EditCharacter />,
        auth: authRoles.admin,
    },
    {
        path: '/parts',
        element: <Parts />,
        auth: authRoles.admin,
    },
    {
        path: '/editPart',
        element: <EditPart />,
        auth: authRoles.admin,
    },
    {
        path: '/editProduct',
        element: <EditProduct />,
        auth: authRoles.admin,
    },
    {
        path: '/emails',
        element: <Emails />,
        auth: authRoles.admin,
    },
    {
        path: '/revisions',
        element: <Revisions />,
        auth: authRoles.admin,
    },
        {
        path: '/questions',
        element: <ChatbotData />,
        auth: authRoles.admin,
    },
    {
        path: '/orders',
        element: <Orders code={true} />,
        auth: authRoles.admin,
    },
    {
        path: '/internet-orders',
        element: <Orders code={false} />,
        auth: authRoles.admin,
    },
    {
        path: '/photos',
        element: <Photos />,
        auth: authRoles.admin,
    },
    {
        path: '/vendors',
        element: <Vendors />,
        auth: authRoles.admin,
    },
    {
        path: '/customers',
        element: <Customers />,
        auth: authRoles.admin,
    },
    {
        path: '/employees',
        element: <Employees />,
        auth: authRoles.admin,
    },
    {
        path: '/blogs',
        element: <Blogs />,
        auth: authRoles.admin,
    },
    {
        path: '/chat',
        element: <Chat />,
        auth: authRoles.admin,
    },
    {
        path: '/managers',
        element: <Managers />,
        auth: authRoles.admin,
    },
    {
        path: '/accountability',
        element: <Accountability />,
        auth: authRoles.admin,
    },
    {
        path: '/reports',
        element: <Reports />,
        auth: authRoles.admin,
    },
    {
        path: '/suppliers',
        element: <Suppliers />,
        auth: authRoles.admin,
    },
    {
        path: '/viewOrder',
        element: <ViewOrder />,
        auth: authRoles.admin,
    },
    {
        path: '/productTypes',
        element: <ProductTypes />,
        auth: authRoles.admin,
    },
    {
        path: '/towns',
        element: <Towns />,
        auth: authRoles.admin,
    },
    {
        path: '/stadiums',
        element: <Stadiums />,
        auth: authRoles.admin,
    },
    {
        path: '/pages',
        element: <Pages />,
        auth: authRoles.admin,
    },
    // {
    //     path: '/admin/help',
    //     element: <Help />,
    //     auth: authRoles.admin,
    // },
    // {
    //     path: '/admin/layouts',
    //     element: <Layouts />,
    //     auth: authRoles.admin,
    // },
    // {
    //     path: '/admin/reportedPosts',
    //     element: <ReportPosts />,
    //     auth: authRoles.admin,
    // },
]

export default dashboardRoutes
